import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import withStyles from '@material-ui/core/styles/withStyles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import * as React from 'react';
import ReactGA from 'react-ga4';
import { Link } from 'react-router-dom';
import Auth from '../services/auth';
import UserDataAccess from '../services/userDataAccess';
import ProgressIndicator from './ProgressIndicator';
const userDataAccess = new UserDataAccess();

const styles = theme => ({
    root: theme.mixins.gutters({
        paddingTop: 16,
        paddingBottom: 16,
        marginTop: theme.spacing(3),
    }),
    logo: {
        maxWidth: '100%',
        margin: 'auto',
        maxHeight: '40px'
    },
    page: {
        backgroundImage: `url(${"images/login_bg.jpg"})`,
        backgroundSize: 'cover',
        minHeight: 'calc(100vh - 24px)',
    },
    center: {
        textAlign: 'center'
    },
    link: {
        textDecoration: 'none'
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative'
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
    forgotLinkText: {
        marginTop: theme.spacing(1)
    }
});

function getSteps() {
    return ['Set User Name', 'Confirm Email'];
}


class Login extends React.Component {


    constructor(props) {
        super(props);
        this.login = this.login.bind(this);
        this.Auth = new Auth();

        this.state = {
            username: this.Auth.getUserLogin() || '',
            password: '',
            updateLogin: false,
            headline: 'SIGN IN',
            hasError: false,
            confirmationSent: false,
            loginErrorMessage: 'Invalid username or password.',
            emailcode: '',
            newusername: '',
            activeStep: 0,
            confirmError: '',
            confirmIdentityError: '',
            sendingConfirmation: false,
            confirmingCode: false,
            loggingIn: false,
            isSSOElegible: false,
            ssoSelected: false,
            UserAccountInFacility: false,
            schema: '',
            isDictator: false,
            upgradeConfirmation: true,
            closeUpgrade: true,
            upgrade: false,
            isUpgraded: false,
            canUpgrade: false,
            userEmail: '',
            showPassword: false
        };
    }

    componentWillMount() {

        if (this.Auth.isAuthenticated() && this.Auth.isValidLogin()) {
            let path = this.props.location.state !== undefined ? this.props.location.state.from.pathname || '/' : '/';
            this.props.history.replace(path);
        }
        else if (this.Auth.isAuthenticated()) {
            this.setState({ updateLogin: true, headline: "Update Login", newusername: this.Auth.getUserEmail() });
        }
        else if (this.Auth.getSSOIdentity().length > 0 && !this.props.match.params.classic) {
            this.props.history.replace('/enterpriselogin');
        }
    }

    handleNext = () => {
        const { activeStep } = this.state;

        this.setState({
            activeStep: activeStep + 1,
        });
    };
    

    isStepOptional = step => {
        return step === 1;
    };

    submit = (event) => {
        event.preventDefault();
        this.login();
    };

    submitConfirmEmail = (event) => {
        event.preventDefault();
        this.onConfirmLogin();

    };

    submitConfirmEmailCode = (event) => {

        event.preventDefault();
        this.onConfirmIdentiy();

    }

    onConfirmIdentiy = () => {


        var code = this.state.emailcode;
        var self = this;
        var request = { EmailCode: code };
        self.setState({ confirmingCode: true });
        userDataAccess.confirmIdentity(request).then(function (rs) {
            if (rs) {
                self.Auth.setValidLogin(true);
                self.props.history.replace("/");
                ReactGA.event({
                    action: 'User Confirmed Identity',
                    category: `${self.Auth.getGaUser()}`
                });
                self.setState({ user: rs, openSnack: true, snackMessage: 'Verification Email Sent', confirmationSent: true, confirmIdentity: '', confirmingCode: false });
            }
            else {
                self.setState({ confirmIdentityError: 'Invalid Email Code', confirmingCode: false  })
            }
        });

    }

    onConfirmLogin = () => {

        var user = this.state.newusername;
        var self = this;
        var request = { Email: user };

        self.setState({ sendingConfirmation: true})
        userDataAccess.confirmUserName(request).then(function (rs) {
            self.setState({ user: rs, openSnack: true, snackMessage: 'Verification Email Sent', confirmationSent: true, confirmError: '', sendingConfirmation: false });
            ReactGA.event({
                action: 'User Requested Verification Email',
                category: `${self.Auth.getGaUser()}`
            });
            self.handleNext();
        }).catch(error => {

            self.setState({ sendingConfirmation: false });
            if (error.response.status === 409) {
                if (error.response.data && error.response.data.Result) {
                    self.setState({ confirmError: error.response.data.Result.Errors.join() });
                } else if (error.response.data && error.response.data.Errors) {
                    self.setState({ confirmError: error.response.data.Errors.join() });
                }
                else {
                    self.setState({ openSnack: true, confirmError: 'Unexpected Error Saving User' });
                }
            } else {
                self.setState({ openSnack: true, confirmError: 'Unexpected Error Saving User' });
            }
        });
    }

   
    handleChange = field => event => {

        const { target: { value } } = event;
        this.setState({ [field]: value });
    }

    toggleShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    }

    handleMouseDownPassword = (event) => {
        event.preventDefault();
    }

    login = () => {

        var self = this;
        self.IsFacilitySet();
        self.setState({ loggingIn: true });
        this.Auth.login(this.state.username, this.state.password)
            .then(function (response) {

                let userType = self.Auth.getUserType();
                if (userType == "Dictator" && self.state.upgradeConfirmation) {
                    userDataAccess.GetIsUpgradedValue(self.Auth.getUserId(), self.Auth.getHomeAccount())
                        .then(function (isUpgraded) {
                            self.setState({ canUpgrade: isUpgraded.data[0].CanUpgrade });

                            //toggle the feature
                            if (!isUpgraded.data[0].CanUpgrade) {
                                self.setState({ upgradeConfirmation: false, loggingIn: false });
                                self.handleClose();
                            }

                            if (isUpgraded.data[0].IsUpgraded) {
                                self.setState({ isUpgraded: true });
                            } else {
                                if (self.state.upgradeConfirmation)
                                    self.setState({ isDictator: true, upgradeConfirmation: false });
                            }
                        })
                        .catch(error => {
                            sessionStorage.clear();
                            self.setState({ hasError: true, loginErrorMessage: `Unexpected error getting upgraded value` });
                        })
                }
                else {
                    self.setState({ loggingIn: false });
                    self.Auth.setSSOIdentity("");
                    if (self.Auth.isValidLogin()) {
                        if (self.Auth.getSSOIdentityColumn() === '' && self.state.UserAccountInFacility === true) {
                            self.setState({ isSSOElegible: true });
                        }
                        else {
                            self.handleClose();
                        }

                    } else {
                        self.setState({ updateLogin: true, headline: "Update Login", newusername: self.Auth.getUserEmail() });
                    }
                }
            }).catch(error => {
                self.setState({ loggingIn: false });
                let errorMessage = self.state.loginErrorMessage;
              
                if (error.response && error.response.data && error.response.data.error_description) {
                    if (error.response.data.error_description === "AccountLocked") {
                        errorMessage = "Maximum login attempts exceeded.  Use the Forgot username or password link to reset your password."
                    }
                    else if (error.response.data.error_description === "AccountHold") {
                        errorMessage = "Your access has been placed on hold. Please contact billingsupport@sisfirst.com or call 678-507-1630."
                    }
                }
                self.setState({ hasError: true, loginErrorMessage: errorMessage });
            });
    }

    handleClickOpen = () => {
        var self = this;
        self.setState({ ssoSelected: true });
        self.Auth.signOut(false);
        window.location = `/api/fedauth?username=${self.state.username}`;
    };

    handleClose = () => {
        var history = this.props.history;
        var self = this;
        let path = self.props.location.state !== undefined ? self.props.location.state.from.pathname || '/' : '/';
         history.replace(path);
    };

    handleCloseUpgrade = () => {
        let self = this;
        self.setState({ upgradeConfirmation: false });
        this.login();
    }

    handleCloseIfIsUpgraded = () => {
        let self = this;
        sessionStorage.clear();
        self.setState({ loggingIn: false, isUpgraded: false });
    }

    handleAcceptUpgrade = () => {
        let self = this;
        let token = self.Auth.getToken();
        let account = self.Auth.getHomeAccount();
        let userId = self.Auth.getUserId();
        let name = self.Auth.getUserName();

        sessionStorage.clear();
        sessionStorage.setItem('access_token', token);
        sessionStorage.setItem('activeAccount', account);
        sessionStorage.setItem('snuser', userId);
        sessionStorage.setItem('userName', name);

        self.setState({ newusername: "" });

        this.props.history.push('/upgradetomodernaccount');
    }

    IsFacilitySet = async () => {
        var self = this;
        await fetch(`/api/fedauth/verify-ssoscheme?username=${encodeURIComponent(self.state.username)}`)
            .then(response => response.json())
            .then(data => {
                const scheme = data.scheme;
                if (scheme === undefined || scheme === null || scheme === "NA") {
                    self.setState({ UserAccountInFacility: false });
                } else {
                    self.setState({ 
                        UserAccountInFacility: true,
                        schema: scheme
                    });                    
                }
            })
            .catch(error => {
                self.setState({ UserAccountInFacility: false });
            });
    }

    render() {
        const { classes } = this.props;
        const steps = getSteps();
        const { activeStep, sendingConfirmation, loggingIn, confirmingCode } = this.state;

        return (<div className={classes.page}>
            <Grid container spacing={6} justifyContent="center">
                <Grid item xs={12} sm={6} md={4}>
                    <Paper className={classes.root} elevation={4}>

                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Grid container spacing={3} justifyContent="center">
                                    <Grid item>
                                        <img className={classes.logo} src='/images/SNChart.jpg' alt='SNChart' />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={3} justifyContent="center">
                                    <Grid item>
                                        <Typography variant="h5">
                                            {this.state.headline}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {!this.state.updateLogin && <Grid item xs={12}>
                                <form onSubmit={this.submit}>
                                    <TextField fullWidth
                                        name="txtUserName"
                                        id="txtUserName"
                                        label="User Name"
                                        required
                                        onChange={this.handleChange('username')}
                                        error={this.state.hasError}
                                        value={this.state.username}
                                    /><br />
                                    <TextField fullWidth
                                        name="txtPassword"
                                        id="txtPassword"
                                        type={this.state.showPassword ? 'text' : 'password'}
                                        required
                                        label="Password"
                                        onChange={this.handleChange('password')}
                                        onKeyPress={(ev) => {
                                            if (ev.key === 'Enter') {

                                                ev.preventDefault();
                                                this.login();
                                            }
                                        }}
                                        error={this.state.hasError}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={this.toggleShowPassword}
                                                        onMouseDown={this.handleMouseDownPassword}
                                                    >
                                                        {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                    {this.state.hasError && <FormHelperText id="name-error-text" error>{this.state.loginErrorMessage}</FormHelperText>}
                                </form>
                                {!this.state.updateLogin && <Link to='/forgotpassword' className={classes.link}>
                                    <Typography align="left" variant="body2" color="primary" className={classes.forgotLinkText} gutterBottom>
                                        Forgot username or password?
                                            </Typography>
                                </Link>}
                            </Grid>}
                            {!this.state.updateLogin && <Grid item xs={12}>
                                <Grid container spacing={6}  justifyContent="center">
                                    <Grid item>
                                        <div className={classes.wrapper}>
                                            <Button disabled={loggingIn} variant="contained" onClick={() => { this.login() }}>Login</Button>
                                            {loggingIn && <CircularProgress size={24} className={classes.buttonProgress} />}
                                        </div>

                                    </Grid>
                                </Grid>
                            </Grid>}

                            {!this.state.updateLogin && <Grid item xs={12}>
                               <br/>
                                <Grid container spacing={0} justifyContent="space-between">
                                    <Grid item xs={4}>
                                        <Divider style={{ marginTop: 10, minWidth: '100%' }} />
                                        </Grid>
                                    <Grid item>
                                        
                                        <Typography variant="subtitle1">
                                            or
                                        </Typography>
                                
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Divider style={{ marginTop: 10, minWidth: '100%' }} />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={3} justifyContent="center">
                                    <Grid item>
                                        {!this.state.updateLogin && <Link to='/enterpriselogin' className={classes.link}>
                                            <Typography align="center" variant="body2" color="primary" gutterBottom>
                                              Sign in with your facility credentials
                                            </Typography>
                                        </Link>}
                                        
                                    </Grid>
                                </Grid>
                                <Divider style={{ marginTop: 10, minWidth: '100%' }} />
                            </Grid>}

                            {this.state.updateLogin && <Grid item xs={12}>
                                <Stepper activeStep={activeStep}>
                                    {steps.map((label) => {
                                        const props = {};
                                        const labelProps = {};
                                        return (
                                            <Step key={label} {...props}>
                                                <StepLabel {...labelProps}>{label}</StepLabel>
                                            </Step>
                                        );
                                    })}
                                </Stepper>
                            </Grid>
                            }
                            {(this.state.updateLogin && !this.state.confirmationSent) && <Grid container>
                                <Grid item xs={12}>
                                    <Typography>
                                        For your added security, an email address is required for your user name.  Please confirm your email address.
                                          <span style={{ color: 'red' }}>  This will become your new SNChart user name.</span>
                                        <br /><br />
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <form id="confirmUserName" onSubmit={this.submitConfirmEmail}>
                                        <TextField fullWidth
                                            name="newusername"
                                            id="newusername"
                                            label="Email"
                                            onChange={this.handleChange('newusername')}
                                            error={this.state.confirmError.length > 0}
                                            value={this.state.newusername}
                                            type="email"
                                            required
                                        />
                                        {this.state.confirmError.length > 0 && <FormHelperText id="name-error-text" error>
                                            {this.state.confirmError}
                                        </FormHelperText>}
                                    </form>
                                    <br /><br />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={6} justifyContent="center">
                                        <Grid item>
                                            <br />
                                            <div className={classes.wrapper}>
                                                <Button disabled={sendingConfirmation} type="submit" form="confirmUserName" onClick={this.submitConfirmEmail} variant="contained" color="primary">Send Verification Code</Button>
                                                {sendingConfirmation && <CircularProgress size={24} className={classes.buttonProgress} />}
                                            </div>
                                            <br /> <br />
                                        </Grid>
                                    </Grid>
                                </Grid></Grid>}
                            {(this.state.updateLogin && this.state.confirmationSent) && <Grid container>
                                <Grid item xs={12}>
                                    <Typography>
                                        Enter confirmation code from the SNChart Email Confirmation you received.  If you do not receive this email, please check your spam or bulk email folder.
                                        <br /><br />
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <form id="confirmEmailCode" onSubmit={this.submitConfirmEmailCode}>
                                        <TextField fullWidth
                                            name="email"
                                            id="email"
                                            label="User Name"
                                            error={this.state.hasError}
                                            required
                                            disabled
                                            value={this.state.newusername}
                                        /><br /><br />
                                        <TextField fullWidth
                                            name="emailCode"
                                            id="emailCode"
                                            label="Email Code"
                                            onChange={this.handleChange('emailcode')}
                                            error={this.state.confirmIdentityError.length > 0}
                                            required
                                            type="number"
                                            value={this.state.emailcode}
                                        />
                                        {this.state.confirmIdentityError.length > 0 && <FormHelperText id="name-error-text" error>
                                            {this.state.confirmIdentityError}
                                        </FormHelperText>}
                                    </form>
                                    <br /><br />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={6} justifyContent="center">
                                        <Grid item>
                                            <br />
                                            <div className={classes.wrapper}>
                                                <Button type="submit" disabled={confirmingCode} form="confirmEmailCode" onClick={this.submitConfirmEmailCode} variant="contained" color="primary">Login</Button>
                                                {confirmingCode && <CircularProgress size={24} className={classes.buttonProgress} />}
                                            </div>

                                            <br /> <br />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>}
                            {this.state.isDictator && this.state.upgradeConfirmation &&
                                <Grid item xs={12}>
                                    <Grid container spacing={3} justifyContent="right">
                                        <Typography align="center" variant="body2" gutterBottom>
                                            Cancel
                                        </Typography>
                                    </Grid>
                                </Grid>}
                            <Grid item xs={12}>
                                <Grid container spacing={3} justifyContent="center">
                                    <Grid item>
                                        <Typography align="center" variant="body2" gutterBottom>
                                            Contact support at
                                        </Typography>
                                        <a href='tel:8008660656' className={classes.link}>
                                            <Typography align="center" variant="body2" gutterBottom>
                                                (800) 866-0656
                                            </Typography>
                                        </a>
                                        <a href="mailto:acctmgrs@surgicalnotes.com?subject=SNChart Customer Request/Issue" className={classes.link}>
                                            <Typography align="center" variant="body2" gutterBottom>
                                                acctmgrs@surgicalnotes.com
                                            </Typography>
                                        </a>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={3} justifyContent="center">
                                    <Grid item xs={12} className={classes.center}>
                                        <img className={classes.logo} src='/images/SNLogo.png' alt='Surgical Notes' />
                                    </Grid>
                                </Grid>
                            </Grid>
                            {this.state.isSSOElegible && <Dialog
                                open={true}
                                onClose={this.handleClose}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Single Sign On"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Would you like to enable single sign on? <br></br>
                                            This will link your Surgical Notes login to your {this.state.schema} Enterprise Login
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.handleClose} color="primary">
                                        Disagree
                                    </Button>
                                    <Button onClick={this.handleClickOpen} color="primary" autoFocus>
                                        Agree
                                    </Button>
                                </DialogActions>
                            </Dialog>}
                            {this.state.isDictator && this.state.canUpgrade && this.state.closeUpgrade &&
                                <Dialog
                                    open={true}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                <DialogTitle id="alert-dialog-title">{"Upgrade to Modern Account"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Would you like to to upgrade to a Modern Account? <br></br>
                                            This will link your Surgical Notes login to your Email Address
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.handleCloseUpgrade} color="primary">
                                        NOT RIGHT NOW
                                    </Button>
                                    <Button onClick={this.handleAcceptUpgrade} color="primary" autoFocus>
                                        YES
                                    </Button>
                                </DialogActions>
                                </Dialog>}
                            {this.state.isUpgraded &&
                                <Dialog
                                    open={true}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">{"Account Upgraded to Modern Account"}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            You are not able to login using this account.<br></br>
                                            Recently you upgraded your account, using a email instead. 
                                            <br /> <br />
                                            Please login with your new credentials.
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                    <Button onClick={this.handleCloseIfIsUpgraded} color="primary">
                                            OK
                                        </Button>
                                    </DialogActions>
                                </Dialog>}
                            {this.state.ssoSelected && <div>
                                <ProgressIndicator showProgressIndicator={this.state.ssoSelected} progressTitle={'Please wait...'} progressText={'Logging in...'} />
                            </div>}
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </div>);
    }

}

export default withStyles(styles)(Login);


// WEBPACK FOOTER //
// ./src/components/Login.js